module.exports = __webpack_public_path__ + "img/search-refraction.1f5081f3.svg";